import { render } from "./InnerPageBanner.vue?vue&type=template&id=057338ce"
import script from "./InnerPageBanner.vue?vue&type=script&lang=js"
export * from "./InnerPageBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__